/**
 * Formatta il tempo in minuti in un formato leggibile
 * Se i minuti sono inferiori a 60, mostra solo i minuti
 * Se sono 60 o più, mostra ore e minuti
 * 
 * @param {number} totalMinutes - Tempo totale in minuti
 * @returns {string} - Stringa formattata (es. "45 min" o "2 ore 15 min")
 */
export const formatDurationMinutes = (totalMinutes) => {
  if (!totalMinutes && totalMinutes !== 0) return '';
  
  // Converti in numero per sicurezza
  const minutes = parseInt(totalMinutes, 10);
  
  if (minutes < 60) {
    return `${minutes} min`;
  } else {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    
    if (remainingMinutes === 0) {
      return hours === 1 ? `${hours} ora` : `${hours} ore`;
    } else {
      return hours === 1 
        ? `${hours} ora ${remainingMinutes} min` 
        : `${hours} ore ${remainingMinutes} min`;
    }
  }
};

/**
 * Formatta la distanza in km
 * 
 * @param {number} distanceKm - Distanza in km
 * @returns {string} - Stringa formattata (es. "13 km")
 */
export const formatDistance = (distanceKm) => {
  if (!distanceKm && distanceKm !== 0) return '';
  
  // Arrotonda a numero intero senza decimali
  return `${Math.round(distanceKm)} km`;
};
